import { Pipe, PipeTransform } from '@angular/core';
import { ShellDomainProvider } from '@ecap3/core';

@Pipe({name: 'customCurrencyShort'})

export class customCurrencyShortPipe implements PipeTransform {
  transform(value: number): string {
    if (value || value === 0) {
			if (Math.abs(Number(value)) >= 1.0e9) {
				return this.convertLongDecimalNumber((Number(value) / 1.0e9).toString()) + 'B';
			} else if (Math.abs(Number(value)) >= 1.0e6) {
				return this.convertLongDecimalNumber((Number(value) / 1.0e6).toString()) + 'M';
			} else if (Math.abs(Number(value)) < 1.0e6 && Math.abs(Number(value)) >= 1.0e5) {
				return this.convertLongDecimalNumber((Number(value) / 1.0e3).toString()) + 'K';
			} else {
				return this.customFormateValue(value.toString());
			}
		}
  }

  customFormateValue(value: string) {
		if (typeof value != 'number' && typeof value != 'string') return null;
		const formattedValue = value.toString();
		const splittedValue = formattedValue.split('.');
		const solidPart = splittedValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		let decimalPart;
		if (splittedValue[1]) {
			splittedValue[1] = splittedValue[1] + '000000000';
			decimalPart = splittedValue[1] ? `,${splittedValue[1].slice(0, 2)}` : ``;
		} else {
			splittedValue.push('000000000');
			decimalPart = splittedValue[1] ? `,${splittedValue[1].slice(0, 2)}` : ``;
		}

		return `${solidPart}${decimalPart}`;
	}

	//convert 1.5647 as 1.5
	convertLongDecimalNumber(value: string) {
		var splitNumbers = value.split('.');
		if (splitNumbers.length > 1) {
			var decimalPart = splitNumbers[1];
			if (decimalPart[0] != '0') {
				return splitNumbers[0] + '.' + decimalPart[0];
			}
		}

		return splitNumbers[0];
	}
}
